<template>
    <div class="padding">
        <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
            <h4>{{ $t('班级列表') }}</h4>
            <div class="flex flex-v-center" style="gap: 20px;">
                <el-input style="border-radius: 20px;" :placeholder="$t('请输入班级名称')" v-model="filterData.name" clearable>
                    <el-button slot="append" @click="getList" icon="el-icon-search"></el-button>
                </el-input>
                <el-button type="primary" @click="add()" icon="el-icon-plus">{{ $t('创建班级') }}</el-button>
            </div>
        </div>

        <el-table v-loading="loading == 'class_list'"
            :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
            class="margin-t" :data="class_list" style="width: 100%">
            <el-empty slot="empty" :description="$t('还没有班级数据')" style="margin-top: 100px;"></el-empty>
            <el-table-column align="center" prop="name" :label="$t('班级名称')" width="140">
            </el-table-column>
            <el-table-column align="center" prop="created_at" :label="$t('创建日期')" width="120">
            </el-table-column>
            <el-table-column align="center" prop="teachers_count" :label="$t('老师人数')">
                <template slot-scope="scope">
                    <el-button :loading="loading == 'get_teachers_' + scope.row.id" @click="get_teachers(scope.row)"
                        size="small" icon="el-icon-edit-outline" type="primary">{{ scope.row.teacher_ids.length }} {{
                            $t('人') }}</el-button>
                </template>
            </el-table-column>

            <el-table-column align="center" prop="students_count" :label="$t('学生人数')">
                <template slot-scope="scope">
                    <el-button size="small" :loading="loading == 'get_students_' + scope.row.id"
                        @click="get_students(scope.row)" icon="el-icon-edit-outline" type="primary">{{
                            scope.row.students_count }} {{
                            $t('人') }}</el-button>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="latest_homework" :label="$t('班级作业')">
                <template slot-scope="scope">
                    <el-button size="small" :loading="loading == 'get_works_' + scope.row.id"
                        @click="get_works(scope.row)" icon="el-icon-edit-outline" type="primary">{{
                            scope.row.works_count }} </el-button>
                </template>
            </el-table-column>

            <el-table-column align="center" :label="$t('操作')" width="190px">
                <template slot-scope="scope">
                    <el-button class="margin-r" @click="edit_class(scope.row)" type="primary" icon="el-icon-edit"
                        size="mini">{{ $t('编辑') }}</el-button>
                    <el-popconfirm v-if="scope.row.user_id == $store.state.user.id" :confirm-button-text="$t('确认')"
                        :cancel-button-text="$t('取消')" @confirm="remove_class(scope.row.id)" :title="$t('确定删除该班级吗？')">
                        <el-button size="mini" slot="reference" icon="el-icon-close">{{ $t('删除') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>



        <el-dialog @close="filterData1.name = ''" fullscreen v-if="clazz" center :title="clazz.name"
            :visible.sync="dialogVisible1" width="50%">
            <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
                <h3>{{ $t('老师列表') }} ( {{ teacher_ids.length }} {{ $t('人') }})</h3>
                <div class="flex flex-v-center" style="gap: 20px;">
                    <el-input style="border-radius: 20px;" :placeholder="$t('请输入老师名称')" v-model="filterData1.name"
                        clearable>
                        <el-button slot="append" @click="get_teachers()" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-button :disabled="teacher_ids.length == 0" type="primary" @click="saveTeachers()"
                        icon="el-icon-check">{{ $t('保存老师') }}</el-button>
                </div>
            </div>
            <el-checkbox-group v-model="teacher_ids" style="width: 100%">
                <el-table size="small"
                    :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
                    class="margin-t" :data="teacher_list" style="width: 100%">
                    <el-empty slot="empty" :image-size="100" :description="$t('还没有老师数据')"
                        style="margin-top: 100px;"></el-empty>
                    <el-table-column align="center" prop="name" :label="$t('图像')">
                        <template slot-scope="scope">
                            <el-avatar :src="$host + scope.row.avatar"></el-avatar>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="name" :label="$t('老师名称')">
                    </el-table-column>

                    <el-table-column align="center" prop="address" :label="$t('添加到班级')">
                        <template slot-scope="scope">
                            <el-checkbox :disabled="$store.state.user.teacher.id == scope.row.id"
                                :label="scope.row.id">&nbsp;</el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-checkbox-group>
        </el-dialog>



        <el-dialog append-to-body @close="filterData1.name = ''" fullscreen v-if="clazz" center :title="clazz.name"
            :visible.sync="dialogVisible2" width="50%">
            <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
                <h3>{{ $t('学生列表') }} ( {{ student_list.length }} {{ $t('人') }})</h3>
                <div class="flex flex-v-center" style="gap: 20px;">
                    <el-input style="border-radius: 20px;" :placeholder="$t('请输入学生名称')" v-model="filterData1.name"
                        clearable>
                        <el-button slot="append" @click="get_students()" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-button type="primary" @click="copy()" icon="el-icon-document-copy">{{ $t('链接添加学生')
                        }}</el-button>
                    <el-button type="primary" @click="add_student()" icon="el-icon-plus">{{ $t('User ID 添加学生')
                    }}</el-button>
                </div>
            </div>
            <el-table size="small"
                :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
                class="margin-t" :data="student_list" style="width: 100%">
                <el-empty slot="empty" :image-size="100" :description="$t('还没有学生数据')"
                    style="margin-top: 100px;"></el-empty>
                <el-table-column align="center" prop="user_id" :label="$t('User ID')">
                </el-table-column>

                <el-table-column align="center" :label="$t('图像')">
                    <template slot-scope="scope">
                        <el-avatar :src="scope.row.avatar"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="name" :label="$t('学生名称')">
                </el-table-column>

                <el-table-column align="center" prop="created_at" :label="$t('加入时间')">
                </el-table-column>


                <el-table-column align="center" prop="address" :label="$t('操作')">
                    <template slot-scope="scope">
                        <el-popconfirm :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')"
                            @confirm="remove_student(scope.row.id)" :title="$t('确定移除该学生吗？')">
                            <el-button size="small" icon="el-icon-close" slot="reference">移除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog append-to-body @close="filterData1.name = ''" fullscreen v-if="clazz" center :title="clazz.name"
            :visible.sync="dialogVisible3" width="50%">
            <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
                <h3>{{ $t('作业列表') }} ( {{ work_list.length }})</h3>
                <div class="flex flex-v-center" style="gap: 20px;">
                    <el-input style="border-radius: 20px;" :placeholder="$t('请输入学生名称')" v-model="filterData1.name"
                        clearable>
                        <el-button slot="append" @click="get_works()" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-button type="primary" :loading="loading == 'add_work'" @click="add_work()"
                        icon="el-icon-plus">{{
                            $t('布置新作业')
                        }}</el-button>
                </div>
            </div>
            <el-table size="small"
                :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
                class="margin-t" v-loading="loading == 'work_list'" :data="work_list" style="width: 100%">
                <el-empty slot="empty" :image-size="100" :description="$t('还没有作业数据')"
                    style="margin-top: 100px;"></el-empty>


                <el-table-column prop="title" align="center" :label="$t('作业标题')">
                </el-table-column>
                <el-table-column align="center" prop="teacher.name" :label="$t('发布老师')">
                    <template slot-scope="scope">
                        <div class="flex flex-v-center flex-h-center">
                            <el-avatar :src="scope.row.teacher.avatar"></el-avatar>
                            <div class="margin-l">
                                {{ scope.row.teacher.name }}
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="teacher.name" :label="$t('作业人数')">
                    <template slot-scope="scope">
                        {{ scope.row.user_ids.length }}
                    </template>
                </el-table-column>

                <el-table-column align="center" prop="created_at" :label="$t('发布时间')">
                </el-table-column>

                <el-table-column align="center" prop="expiry_time" :label="$t('截止时间')">
                </el-table-column>

                <el-table-column align="center" prop="address" :label="$t('操作')">
                    <template slot-scope="scope">
                        <el-button class="margin-r" v-if="scope.row.user_id == $store.state.user.id"
                            :loading="loading == 'add_work_' + scope.row.id" @click="add_work(scope.row)" size="small"
                            type="primary" icon="el-icon-edit" slot="reference">编辑</el-button>
                        <el-button class="margin-r" v-else :loading="loading == 'add_work_' + scope.row.id"
                            @click="add_work(scope.row, 1)" size="small" type="primary" icon="el-icon-info"
                            slot="reference">查看</el-button>
                        <el-popconfirm v-if="scope.row.user_id == $store.state.user.id" :confirm-button-text="$t('确认')"
                            :cancel-button-text="$t('取消')" @confirm="remove_work(scope.row.id)"
                            :title="$t('确定删除该作业吗？')">
                            <el-button size="small" icon="el-icon-close" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog @close="work_close()" append-to-body top="20px" v-if="clazz" center :title="clazz.name"
            :visible.sync="dialogVisible4" width="60%">
            <div class="flex flex-between flex-v-center" style="padding: 0 10px;">
                <h3>{{ form.id ? (work_flag ? $t('查看作业') : $t('编辑作业')) : $t('布置作业') }}</h3>
            </div>

            <el-steps class="margin-t" :active="active" simple>
                <el-step title="选择学生" icon="el-icon-user"></el-step>
                <el-step title="填写学生作业" icon="el-icon-edit"></el-step>
            </el-steps>

            <div v-if="active == 0">
                <div v-if="!work_flag" class="margin-t flex flex-h-end" style="gap: 20px;">
                    <el-button @click="set_student_ids(1)" round>{{ $t('全选') }}</el-button>
                    <el-button round type="primary" @click="set_student_ids()" :disabled="student_ids.length == 0">{{
                        $t('取消所有选择')
                        }}</el-button>
                </div>

                <el-checkbox-group v-model="student_ids" style="width: 100%">
                    <el-table size="small" v-if="active == 0"
                        :header-cell-style="{ backgroundColor: $store.state.theme === 'dark' ? '#444 !important' : '#f5f7fa', color: $store.state.theme === 'dark' ? '#fff' : '#333' }"
                        class="margin-t" :data="student_list" style="width: 100%">
                        <el-empty slot="empty" :image-size="100" :description="$t('还没有学生数据')"
                            style="margin-top: 100px;"></el-empty>
                        <el-table-column align="center" prop="user_id" :label="$t('User ID')">
                        </el-table-column>

                        <el-table-column align="center" :label="$t('图像')">
                            <template slot-scope="scope">
                                <el-avatar :src="scope.row.avatar"></el-avatar>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="name" :label="$t('学生名称')">
                        </el-table-column>

                        <el-table-column align="center" prop="created_at" :label="$t('加入时间')">
                        </el-table-column>


                        <el-table-column align="center" :label="$t('选择')">
                            <template slot-scope="scope">
                                <el-checkbox :disabled="work_flag" :label="scope.row.id">
                                    <div></div>
                                </el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-checkbox-group>
                <div class="margin-lt flex flex-h-center" style="gap: 20px;">
                    <el-button v-if="!work_flag" @click="dialogVisible4 = false" icon="el-icon-close" round>{{ $t('取消') }}</el-button>
                    <el-button :plain="work_flag" round :disabled="student_ids.length == 0"
                        :icon="work_flag ? 'el-icon-right' : 'el-icon-check'" @click="active = 1" type="primary">{{
                            work_flag ? $t('下一步') : $t('确认选择')
                        }}</el-button>
                </div>

            </div>

            <div v-else-if="active == 1">
                <div class="margin-lt">
                    <el-form ref="form" label-position="top" :model="form" label-width="80px">
                        <el-form-item prop="title" :rules="[
                            { required: true, message: $t('作业标题不能为空') },
                        ]" :label="$t('作业标题')">
                            <el-input :readonly="work_flag" :placeholder="$t('请输入作业标题')"
                                v-model="form.title"></el-input>
                        </el-form-item>

                        <el-form-item prop="expiry_time" :rules="[
                            { required: true, message: $t('作业截止时间不能为空') },
                        ]" :label="$t('作业截止时间')">
                            <el-date-picker :readonly="work_flag" type="datetime" default-time="23:59:59"
                                value-format="yyyy-MM-dd HH:mm:ss" formate="yyyy-MM-dd 23:59:59"
                                :placeholder="$t('请选择作业截止时间')" v-model="form.expiry_time"></el-date-picker>
                        </el-form-item>


                        <el-form-item prop="content" :rules="[
                            { required: true, message: $t('作业内容不能为空') },
                        ]" :label="$t('作业内容')">
                            <el-input :readonly="work_flag" type="textarea" :rows="6" :placeholder="$t('请输入作业内容')"
                                v-model="form.content">
                            </el-input>

                            <div v-for="(item, i) in form.attachment" :key="i">
                                <el-divider></el-divider>
                                <div class="flex flex-between flex-v-center">
                                    <template v-if="item.type == 'audio'">
                                        <audio controls v-if="item.url" :src="$host + item.url"></audio>
                                        <audio-recorder v-else :index="i" @start="set_audio_index" @content="set_audio"
                                            :time_limit="120" :submittable="false"></audio-recorder>
                                    </template>

                                    <el-image :preview-src-list="[$host + item.url]" v-else-if="item.type == 'image'"
                                        style="height: 100px;width: 200px;" fit="cover"
                                        :src="$host + item.url"></el-image>
                                    <el-link v-else-if="item.type == 'file'">{{ item.url.split('/').pop()
                                    }}</el-link>

                                    <div class="flex flex-v-center">
                                        <el-tooltip :content="$t('下载')" v-if="item.url">
                                            <el-button @click="open_attachment(i)" style="font-size: 25px;" type="text"
                                                icon="el-icon-download"></el-button>
                                        </el-tooltip>
                                        <el-tooltip :content="$t('移除')">
                                            <el-button @click="remove_attachment(i)" style="font-size: 25px;"
                                                type="text" icon="el-icon-close"></el-button>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>

                            <div v-if="!work_flag" class="flex flex-v-center margin-ts">

                                <el-button style="font-size: 16px;" @click="add_audio()" type="text" size="large"
                                    icon="el-icon-service">{{
                                        $t('添加音频') }}</el-button>

                                <el-divider class="margin-x" direction="vertical"></el-divider>
                                <el-upload accept="image/jpeg,image/jpg,image/png" :headers="headers" :action="action"
                                    :show-file-list="false" :on-success="handleImageSuccess">
                                    <el-button style="font-size: 16px;" type="text" size="large"
                                        icon="el-icon-picture">{{
                                            $t('添加图片') }}</el-button>
                                </el-upload>
                                <el-divider class="margin-x" direction="vertical"></el-divider>
                                <el-upload accept=".pdf,.doc,.docx,.xls,.xlsx" :headers="headers" :action="action"
                                    :show-file-list="false" :on-success="handleFileSuccess">
                                    <el-button style="font-size: 16px;" type="text" size="large"
                                        icon="el-icon-document-add">{{
                                            $t('添加文件') }}</el-button>
                                </el-upload>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="margin-lt flex flex-h-center" style="gap: 20px;">
                    <el-button @click="active = 0" :icon="work_flag?'el-icon-back':'el-icon-refresh-right'" round>{{
                        work_flag ? $t('上一步'):$t('重新选择学生')
                        }}</el-button>
                    <el-button v-if="!work_flag" round :loading="loading == 'submit_work'" icon="el-icon-check" @click="submit_work()"
                        type="primary">{{ $t('确认发布')
                        }}</el-button>
                </div>

            </div>
        </el-dialog>

        <share-dialog ref="shareDialog"></share-dialog>
    </div>
</template>


<script>
import AudioRecorder from '@/components/AudioRecorder.vue';
import shareDialog from '@/components/ShareDialog.vue';

export default {
    components: { shareDialog, AudioRecorder },
    data() {
        return {
            action: 'https://www.ptefighter.com/api/work/upload',
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            filterData1: { name: '' },
            filterData: { name: '' },
            class_list: [],
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            dialogVisible4: false,
            clazz: null,
            teacher_list: [],
            teacher_ids: [],
            student_list: [],
            work_list: [],
            student_ids: [],
            active: 0,
            form: {
                title: '',
                expiry_time: '',
                content: '',
                attachment: []
            },
            audio_index: 0,
            delete_urls: [],
            loading: null,
            work_flag: false
        }
    },
    created() {
        this.getList();
    },
    methods: {
        set_audio_index(index) {
            this.audio_index = index
        },

        set_audio(file) {
            this.form.attachment[this.audio_index].file = file
        },

        add_audio() {
            this.form.attachment.push({
                type: 'audio'
            })
        },
        edit_class(clazz) {
            this.$prompt('', this.$t('编辑班级'), {
                inputValue: '',
                center: true,
                roundButton: true,
                inputPlaceholder: this.$t('请输入班级名称'),
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
            }).then(({ value }) => {
                if (value) {
                    this.$http.post("/api/class/save", { id: clazz.id, name: value }).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t("编辑成功")
                        });
                        this.getList();
                    })
                }
            }).catch(() => {

            });
        },
        remove_class(id) {
            this.$http.post("/api/class/remove", { id }).then(() => {
                this.$message({
                    message: this.$t('删除成功'),
                    type: 'success'
                })
                this.getList()
            })
        },
        work_close() {
            if (this.form.attachment.length > 0) {
                const urls = this.form.attachment.filter(v => v.is_new).map(v => v.url)
                if (urls.length > 0) {
                    this.$http.post("/api/work/upload/remove", { urls })
                }
            }
        },
        submit_work() {
            this.loading = 'submit_work'
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.form.clazz_id = this.clazz.id
                    this.form.user_ids = this.student_ids

                    for (let i = 0; i < this.form.attachment.length; i++) {
                        if (this.form.attachment[i].file) {
                            let formData = new FormData();
                            formData.append("file", this.form.attachment[i].file);
                            const url = await this.$http.post('/api/work/upload', formData, {
                                timeout: 60000,
                                headers: {
                                    'Content-type': 'multipart/form-data'
                                }
                            })
                            this.form.attachment[i].url = url
                            delete this.form.attachment[i].file
                        }
                        delete this.form.attachment[i].is_new
                    }



                    this.$http.post('/api/work/save', this.form).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t("作业发布成功")
                        })
                        if (this.delete_urls.length > 0) {
                            this.$http('/api/work/upload/remove', { urls: this.delete_urls })
                        }
                        this.form.attachment = []
                        this.get_works()
                        this.dialogVisible4 = false
                        this.loading = null
                    })
                } else {
                    this.loading = null
                    return false;
                }

            });
        },

        open_attachment(i) {
            window.open(this.$host + this.form.attachment[i].url)
        },

        remove_attachment(i) {
            if (!this.form.attachment[i].url) {
                this.form.attachment.splice(i, 1)
                return
            }
            if (this.form.attachment[i].is_new) {
                const urls = [this.form.attachment[i].url]
                this.$http.post("/api/work/upload/remove", { urls }).then(() => {
                    this.form.attachment.splice(i, 1)
                })
            } else {
                this.delete_urls.push(this.form.attachment[i].url)
                this.form.attachment.splice(i, 1)
            }

        },

        handleAudioSuccess(url) {
            this.form.attachment.push({
                type: 'audio',
                url,
                is_new: 1
            })
        },
        handleImageSuccess(url) {
            this.form.attachment.push({
                type: 'image',
                url,
                is_new: 1
            })
        },
        handleFileSuccess(url) {
            this.form.attachment.push({
                type: 'file',
                url,
                is_new: 1
            })
        },

        set_student_ids(flag) {
            if (flag) {
                this.student_ids = this.student_list.map(v => v.id)
            } else {
                this.student_ids = []
            }
        },
        add_work(row, flag) {
            this.work_flag = flag ? true : false
            if (row) {
                this.loading = 'add_work_' + row.id
            } else {
                this.loading = 'add_work'
            }

            this.delete_urls = []
            this.$http.post("/api/student/list", { clazz_id: this.clazz.id }).then((list) => {
                this.student_list = list
                this.active = 0
                if (row) {
                    console.log(row)
                    this.student_ids = row.user_ids
                    this.form.id = row.id
                    this.form.title = row.title
                    this.form.expiry_time = row.expiry_time
                    this.form.content = row.content
                    this.form.attachment = JSON.parse(JSON.stringify(row.attachment))
                } else {
                    this.student_ids = []
                    this.form.id = undefined
                    this.form.title = ''
                    this.form.expiry_time = ''
                    this.form.content = ''
                    this.form.attachment = []
                }


                this.dialogVisible4 = true
                this.loading = false
            })
        },
        copy() {
            this.$refs.shareDialog.show("链接添加学生", "https://www.ptefighter.com/main/class?code=" + this.clazz.code, "请一键复制以下链接发给添加学生", "80%");
        },
        saveTeachers() {
            this.$http.post("/api/class/teacher", { clazz_id: this.clazz.id, teacher_ids: this.teacher_ids }).then(() => {
                this.clazz.teacher_ids = this.teacher_ids
                this.$message({
                    type: 'success',
                    message: this.$t("保存成功")
                });
                this.dialogVisible1 = false
            })
        },
        getList() {
            this.loading = 'class_list'
            this.$http.post('/api/class/list', this.filterData).then(res => {
                this.class_list = res.data;
                this.loading = null
            });
        },
        to(path) {
            this.$router.push(path);
        },
        add() {
            this.$prompt('', this.$t('创建班级'), {
                inputValue: '',
                center: true,
                roundButton: true,
                inputPlaceholder: this.$t('请输入班级名称'),
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
            }).then(({ value }) => {
                if (value) {
                    this.$http.post("/api/class/save", { name: value }).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t("创建成功") + "!"
                        });
                        this.getList();
                    })
                }
            }).catch(() => {

            });
        },

        remove_work(id) {
            this.$http.post("/api/work/remove", { id }).then(() => {
                this.$message({
                    type: 'success',
                    message: this.$t("删除成功")
                });
                this.get_works();
            })
        },

        remove_student(user_id) {
            this.$http.post("/api/student/remove", { user_id, clazz_id: this.clazz.id }).then(() => {
                this.$message({
                    type: 'success',
                    message: this.$t("移除成功")
                });
                this.get_students();
            })
        },

        add_student() {
            this.$prompt('', this.$t('添加学生'), {
                inputValue: '',
                center: true,
                roundButton: true,
                inputPlaceholder: this.$t('请输入学生 User ID'),
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
            }).then(({ value }) => {
                if (value) {
                    this.$http.post("/api/student/add", { user_id: value, clazz_id: this.clazz.id }).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t("添加成功")
                        });
                        this.clazz.students_count += 1
                        this.get_students();
                    })
                }
            }).catch(() => {

            });
        },
        get_teachers(clazz) {
            if (clazz) {
                this.clazz = clazz;
                this.loading = 'get_teachers_' + clazz.id
            } else {
                this.loading = 'get_teachers'
            }

            this.$http.post("/api/teacher/list", { clazz_id: this.clazz.id, ...this.filterData1 }).then((list) => {
                this.teacher_ids = this.clazz.teacher_ids || []
                const teacher_list = []
                this.teacher_ids.forEach((id) => {
                    const index = list.findIndex((t) => t.id === id)
                    if (index !== -1) {
                        teacher_list.push(list.splice(index, 1)[0])
                    }
                })
                this.teacher_list = teacher_list.concat(list)
                this.dialogVisible1 = true
                this.loading = null
            })
        },

        get_students(clazz) {
            if (clazz) {
                this.clazz = clazz;
                this.loading = 'get_students_' + clazz.id
            } else {
                this.loading = 'get_students'
            }
            this.$http.post("/api/student/list", { clazz_id: this.clazz.id, ...this.filterData1 }).then((list) => {
                this.student_list = list
                this.dialogVisible2 = true
                this.loading = false
            })
        },
        get_works(clazz) {
            if (clazz) {
                this.clazz = clazz;
                this.loading = 'get_works_' + clazz.id
            } else {
                this.loading = 'get_works'
            }
            this.$http.post("/api/work/list", { clazz_id: this.clazz.id, ...this.filterData1 }).then((list) => {
                this.work_list = list
                this.dialogVisible3 = true
                this.loading = false
            })
        }
    }
};
</script>
